import { render } from "./PlanMetrics.vue?vue&type=template&id=598bda75&scoped=true"
import script from "./PlanMetrics.vue?vue&type=script&lang=js"
export * from "./PlanMetrics.vue?vue&type=script&lang=js"

import "./PlanMetrics.vue?vue&type=style&index=0&id=598bda75&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598bda75"]])

export default __exports__